import Vue from 'vue'

// ─────────────────────────────────────────────────────────────────────────────
// Approval Requests — end-user app (site-api, group ② in the API contract).
// Shared by Camera Bypass AND Temp Disarm: an approval_request carries an
// `action` (bypass | clear_bypass | temp_disarm | arm | disarm). Note: there is
// no clear_temp_disarm action — it was permanently dropped (CHEKT-1995).
// All responses carry `server_time`; 409/410 return the resource, not just an error.
// Errors surface as err.body.error_code (see SPEC-2 §8).
// ─────────────────────────────────────────────────────────────────────────────

function buildQuery (params) {
  const q = Object.keys(params)
    .filter(k => params[k] !== undefined && params[k] !== null && params[k] !== '')
    .map(k => `${k}=${encodeURIComponent(params[k])}`)
  return q.length ? `?${q.join('&')}` : ''
}

export default {
  apiPrefix: '/api/v2/sites',

  // GET /api/v2/sites/{site_id}/approval-requests  (appListApprovalRequests)
  // `status` accepts comma-joined values ("pending,approved"); `action` does NOT
  // — it's a single enum on the backend (bypass|clear_bypass|temp_disarm|arm|disarm),
  // so pass one action or omit it and filter client-side. Default status is pending.
  listApprovalRequests: function ({ siteId, status, action, limit, offset }) {
    const query = buildQuery({ status, action, limit, offset })
    return Vue.http.get(
      Vue.env.apiPath + `${this.apiPrefix}/${siteId}/approval-requests${query}`,
      Vue.auth.getBearerHeader()
    )
  },

  // GET /api/v2/sites/{site_id}/approval-requests/{request_id}  (appGetApprovalRequest)
  getApprovalRequest: function ({ siteId, requestId }) {
    return Vue.http.get(
      Vue.env.apiPath + `${this.apiPrefix}/${siteId}/approval-requests/${requestId}`,
      Vue.auth.getBearerHeader()
    )
  },

  // POST /api/v2/sites/{site_id}/approval-requests/{request_id}/approve
  // (appApproveApprovalRequest) — no request body.
  approveApprovalRequest: function ({ siteId, requestId }) {
    return Vue.http.post(
      Vue.env.apiPath + `${this.apiPrefix}/${siteId}/approval-requests/${requestId}/approve`,
      {},
      Vue.auth.getBearerHeader()
    )
  },

  // POST /api/v2/sites/{site_id}/approval-requests/{request_id}/decline
  // (appDeclineApprovalRequest) — no request body.
  declineApprovalRequest: function ({ siteId, requestId }) {
    return Vue.http.post(
      Vue.env.apiPath + `${this.apiPrefix}/${siteId}/approval-requests/${requestId}/decline`,
      {},
      Vue.auth.getBearerHeader()
    )
  },
}
